import { Entity } from "../core/entity";
export class BasicChatPayload extends Entity {
    get content() {
        return this.dto.content;
    }
}
